exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, "textarea[data-v-6957e78c]{width:100%;height:auto}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6957e78c","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/document-parts/pricing-table-textarea.vue
// module id = 416
// module chunks = 0